export default {
      id: "i-main-investments-03-usage",
      viewBox: "0 0 201 84",
      url: __webpack_public_path__ + "img/sprite.svg#i-main-investments-03",
      toString: function () {
        return this.url;
      }
    }